<template>
  <div class="serviceDialog">
    <el-dialog
      :title="serviceDialogTitle"
      :visible.sync="serviceDialogVisible"
      :close-on-click-modal="false"
      :before-close="close"
      width="60%"
    >
      <el-form
        ref="serviceDataForm"
        :model="serviceData"
        :rules="serviceDataRule"
        label-width="70px"
        :disabled="isEdit"
      >
        <el-row>
          <el-col :span="8">
            <el-form-item label="产品" prop="productId">
              <el-select
                placeholder="请选择产品"
                v-model="serviceData.productId"
                filterable
                class="inputWidth"
                clearable
                @change="(val) => handleChange(val, 'product')"
              >
                <el-option
                  v-for="(item, index) in productList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="服务" prop="serviceNo">
              <el-select
                placeholder="请选择服务"
                v-model="serviceData.serviceNo"
                filterable
                class="inputWidth"
                clearable
                @change="handleService"
              >
                <el-option
                  v-for="(item, index) in serviceList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="expenses-box">
        <div class="expenses-title">{{ expensesTitle }}</div>
        <vxe-toolbar>
          <template v-slot:buttons>
            <el-button @click="insertEvent" size="small" type="primary" class="vxe-btn-primary"
              >添加费目</el-button
            >
            <el-button
              @click="handleDelete('expensesTable')"
              size="small"
              type="danger"
              class="vxe-btn-delete"
              >删除</el-button
            >
          </template>
        </vxe-toolbar>
        <vxe-table
          border
          show-overflow
          resizable
          size="mini"
          align="center"
          ref="expensesTable"
          :auto-resize="true"
          :edit-rules="tableRules"
          :edit-config="{ trigger: 'click', mode: 'row' }"
          :data="expensesTableData"
          @cell-click="cellClick"
          @edit-closed="linkTextChange"
        >
          <vxe-table-column type="checkbox" width="60"></vxe-table-column>
          <vxe-table-column type="index" width="60" title="序号"></vxe-table-column>
          <vxe-table-column
            field="expenseNo"
            title="费目"
            :edit-render="{
              name: 'default',
            }"
          >
            <template v-slot:edit="scope">
              <el-select
                v-model="scope.row.expenseNo"
                clearable
                filterable
                @change="handleExpenseChange"
              >
                <el-option
                  v-for="(item, index) in currExpenseList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                ></el-option>
              </el-select>
            </template>
            <template v-slot="{ row }">{{
              transferSelect(row.expenseNo, currExpenseList)
            }}</template>
          </vxe-table-column>
          <vxe-table-column
            field="remark"
            title="备注"
            :edit-render="{
              name: 'ElInput',
              defaultValue: '',
              props: { clearable: true, maxlength: 32 },
            }"
          >
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="dialog-footer" v-if="!isApproval">
        <el-button type="primary" @click="serviceSubmit">{{ '提交' }}</el-button>
        <el-button @click="close">{{ $t('confirm.cancel') }}</el-button>
      </div>
      <div class="dialog-footer" v-if="isApproval">
        <el-button type="primary" @click="handleReject('0')">{{ '审批通过' }}</el-button>
        <el-button @click="handleReject('1')">{{ '审批驳回' }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/intermodality/service';
  import { mapState } from 'vuex';
  import XEUtils from 'xe-utils';
  export default {
    name: 'serviceDialog',
    props: [
      'isEdit',
      'serviceDialogVisible',
      'productList',
      'editServiceCode',
      'railwayServiceList',
      'subwayList',
      'waterwayList',
      'id',
      'isApproval',
    ],
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      serviceDialogTitle() {
        return this.isApproval ? '审批服务' : this.isEdit ? '编辑服务' : '新增服务';
      },
      serviceDataRule() {
        return {
          productId: [
            {
              required: true,
              message: '请选择产品',
              trigger: ['blur', 'change'],
            },
          ],
          serviceNo: [
            {
              required: true,
              message: '请选择服务',
              trigger: ['blur', 'change'],
            },
          ],
        };
      },
    },
    data() {
      return {
        serviceData: {
          productId: '',
          serviceNo: '',
        },
        expensesTitle: '费目信息',
        expensesTableData: [],
        tableRules: {},
        // serviceList: [],
        repeatFlag: false,
        currExpenseList: [],
      };
    },
    mounted() {
      if (this.editServiceCode) {
        // 根据code查询详情
        console.log('1111111');
        this.getServiceDetail();
      }
    },
    methods: {
      handleExpenseChange(val) {
        const arr = [];
        let expensesData = this.$refs.expensesTable.getTableData().fullData;
        expensesData.forEach((expenses) => {
          arr.push(expenses.expenseNo);
        });
        this.currExpenseList.forEach((item) => {
          if (item.value === val || arr.includes(item.value)) {
            item.disabled = true;
          } else {
            item.disabled = false;
          }
        });
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      getServiceDetail() {
        const params = {
          code: this.editServiceCode,
          adminFlag: this.userInfo.adminFlag,
        };
        this.$axios.post(API.SERVICE_DETAIL, params).then((res) => {
          console.log(res, '======');
          if (res.data.code === 0) {
            const data = res.data.data || {};
            this.expensesTableData = data.listExpense;
            this.serviceData.productId = data.productId;
            this.version = data.version;
            // 查询当前费目列表
            this.$nextTick(() => {
              this.getCurrExpenseList(data.productId, data.serviceNo);
              this.handleChange(data.productId);
              this.serviceData.serviceNo = data.serviceNo;
            });
          }
        });
      },
      // 查询当前费目列表
      getCurrExpenseList(productId, serviceNo) {
        if (!productId) return;
        if (!serviceNo) return;
        this.currExpenseList = [];
        let params = {
          productId,
          serviceNo,
        };
        this.$axios.post(API.CURR_EXPENSE, params).then((res) => {
          if (res.data.code === 0) {
            const list = res.data.data || [];
            if (this.isEdit) {
              const arr = [];
              this.expensesTableData.forEach((expenses) => {
                arr.push(expenses.expenseNo);
              });
              list.forEach((item) => {
                if (item.expenseNo)
                  this.currExpenseList.push({
                    label: item.expenseName,
                    value: item.expenseNo,
                    disabled: arr.includes(item.expenseNo) ? true : false,
                  });
              });
            } else {
              // this.currExpenseList = list;
              list.forEach((item) => {
                this.currExpenseList.push({
                  label: item.expenseName,
                  value: item.expenseNo,
                  disabled: false,
                });
              });
            }
          }
        });
      },
      close() {
        this.$emit('closeDialog', false);
      },
      async handleService() {
        const params = this.serviceData;
        await this.checkName(params);
        await this.getCurrExpenseList(params.productId, params.serviceNo);
      },
      // 查重
      async checkName(params) {
        await this.$axios.post(API.CHECK_NAME, params).then((res) => {
          if (res.data.code === 0) {
            this.repeatFlag = false;
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
          } else {
            this.repeatFlag = true;
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'warning',
            });
          }
        });
      },
      serviceSubmit() {
        this.$refs['serviceDataForm'].validate((valid) => {
          if (valid) {
            if (this.repeatFlag)
              return this.$message({
                showClose: true,
                message: '添加的服务名称重复',
                type: 'error',
              });
            let expensesData = this.$refs.expensesTable
              .getTableData()
              .fullData.filter((expenses) => expenses.expenseNo);
            expensesData.forEach((item) => {
              if (item._XID) {
                delete item._XID;
              }
            });
            let params = {
              productId: this.serviceData.productId,
              serviceNo: this.serviceData.serviceNo,
              adminFlag: this.userInfo.adminFlag,
              listExpense: expensesData,
            };
            if (this.isEdit) {
              params.version = this.version;
              params.code = this.editServiceCode;
              params.id = this.id;
            }
            params.companyCode = this.userInfo.companyCode;
            params.departmentCode = this.userInfo.departmentCode;
            this.$axios.post(API.ADD_SERVICE, params).then((res) => {
              if (res.data.code === 0) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success',
                });
                this.$emit('closeDialog', false);
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          }
        });
      },
      handleChange(val) {
        this.currExpenseList = [];
        if (val == 0) {
          // 公路运输
          this.serviceData.serviceNo = '';
          this.serviceList = this.subwayList;
        } else if (val == 2) {
          this.serviceData.serviceNo = '';
          this.serviceList = this.waterwayList;
        } else {
          // 铁路运输
          this.serviceData.serviceNo = '';
          this.serviceList = this.railwayServiceList;
        }
      },
      handleDelete(tableType) {
        // const expensesData = this.$refs.expensesTable.getTableData().fullData;
        const selectedList = this.$refs[tableType].getSelectRecords(); // 或许选中数据
        if (selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('goods.message.noChooseDel'),
            type: 'error',
          });
          return;
        }
        this.$confirm('是否确认删除')
          .then(() => {
            this.$refs[tableType].removeSelecteds();
            const deleteArr = [];
            selectedList.forEach((selected) => {
              deleteArr.push(selected.expenseNo);
            });
            this.currExpenseList.forEach((curr) => {
              if (deleteArr.includes(curr.value)) {
                curr.disabled = false;
              }
            });
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('goods.message.delSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('goods.message.unDel'),
            });
          });
        // this.$confirmAction()
        //   .then(() => {
        //     this.$refs[tableType].removeSelecteds();
        //     this.$message({
        //       showClose: true,
        //       type: 'success',
        //       message: this.$t('goods.message.delSuccess'),
        //     });
        //   })
        //   .catch(() => {
        //     this.$message({
        //       showClose: true,
        //       type: 'info',
        //       message: this.$t('goods.message.unDel'),
        //     });
        //   });
        // expensesData.forEach((expense, index) => {
        //   selectedList.forEach((row) => {
        //     if (expense.name === row.name && expense.name) {
        //       expensesData.splice(index, 1);
        //     }
        //   });
        // });
      },

      linkTextChange(value) {
        console.log(value, 'linkTextChange');
      },
      cellClick(val) {
        console.log(val, 'cellClick');
      },
      // 新增行
      insertEvent() {
        // 新增时 判断表里面有的费目
        let expensesData = this.$refs.expensesTable.getTableData().fullData;
        this.currExpenseList.forEach((item) => {
          expensesData.forEach((expenses) => {
            if (item.value === expenses.expenseNo) {
              item.disabled = true;
            }
          });
        });
        this.$refs['expensesTable'].validate((valid) => {
          if (valid) {
            let record = {
              expenseNo: '',
              remark: '',
            };
            this.$refs.expensesTable
              .insert(record, -1)
              .then(({ row }) => this.$refs.expensesTable.setActiveRow(row));
            // this.exportFirstData();
          }
        });
      },
      // 审批
      handleReject(val) {
        let params = {
          code: this.editServiceCode,
          isApproval: val,
        };
        this.$axios.post(API.APPROVAL, params).then((res) => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.close();
            this.$router.go(-1);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .dialog-footer {
    text-align: center;
  }
  .expenses-box {
    margin-bottom: 30px;
    .expenses-title {
      height: 40px;
      line-height: 40px;
      margin-bottom: 15px;
    }
  }
</style>
